import React, { useContext, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import { NavLink } from "react-router-dom";
// import Logo from "../../Assets/images/logoh.png";
import SidebarMenu from "../Cpanel/Sidebar/SidebarMenu";
import { routes } from "../Cpanel/data/ShopData";
import { ShopContext, ShopListContext } from "../StateManagement/Contexts/ShopContext";
const ShopSidebar = () => {

  const {shopData} = useContext(ShopContext)
  const [isOpen, setIsOpen] = useState(true);

  // Filter routes based on the 'type' prop
  const filteredRoutes = routes.filter((route) => {
    if (shopData?.type === 1) {
      return route.online; 
    } else if (shopData?.type === 2) {
      return route.offline; 
    }
    return true;
  });

  return (
    <div className="box border-right" id="sidebar">
      <Navbar className="flex-column ">
        <Navbar.Collapse id="basic-navbar-nav">
          <div className=" d-flex flex-column align-items-start justify-content-start w-100">
            <div className="d-flex justify-content-center align-items-center m-auto flex-wrap pt-1">
              {/* <img src={Logo} width={80} alt="logo" /> */}
            </div>
            <section className="routes">
              {filteredRoutes?.map((route, index) => {
                if (route.subRoutes) {
                  return (
                    <SidebarMenu
                      key={index}
                      setIsOpen={setIsOpen}
                      route={route}
                      isOpen={isOpen}
                    />
                  );
                }
                const IconComponent = route.icon;
                return (
                  <NavLink
                    to={route.path}
                    key={index}
                    className="link mx-1"
                    activeclassname="active"
                  >
                    <div className="icon">{IconComponent}</div>
                    {isOpen && <div className="link_text">{route.name}</div>}
                  </NavLink>
                );
              })}
            </section>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default ShopSidebar;
